<template>
    <v-row
        style="min-width: 670px; height: 200px; background-color: black; color: white;"
        class="px-0 py-1 rounded-xl ml-1"
        align="center"
        justify="center"
    >
        <v-col
            cols="12"
            class="px-0 py-0 my-0 d-flex align-center justify-center"
        >
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                <img
                    :src="`${assetsUrl}/${match.team1?.logo}`"
                    width="80px"
                    height="auto"
                    contain
                    class="mr-5"
                >
                <div class="circular-border">
                    <v-progress-circular
                        :size="150"
                        :width="20"
                        :value="(getMade(match.team1) / getAttempts(match.team1)).toFixed(2) * 100"
                        :color="colors.team1"
                        style="font-size: 1.5rem;"
                    >
                        <div class="white--text">
                            ({{ getMade(match.team1) }} / {{ getAttempts(match.team1) }})
                        </div>
                        <div class="white--text">
                            {{ ((getMade(match.team1) / getAttempts(match.team1)).toFixed(2) * 100).toFixed(0) }}%
                        </div>
                    </v-progress-circular>
                </div>
                <span class="px-0 mx-5 custom-orange-text font-weight-bold" style="font-size: 2rem;">
                    {{ type }}
                </span>
                <div class="circular-border">
                    <v-progress-circular
                        :size="150"
                        :width="20"
                        :value="(getMade(match.team2) / getAttempts(match.team2)).toFixed(2) * 100"
                        :color="colors.team2"
                        style="font-size: 1.5rem;"
                    >
                        <div class="white--text">
                            ({{ getMade(match.team2) }} / {{ getAttempts(match.team2) }})
                        </div>
                        <div class="white--text">
                            {{ ((getMade(match.team2) / getAttempts(match.team2)).toFixed(2) * 100).toFixed(0) }}%
                        </div>
                    </v-progress-circular>
                </div>
                <img
                    :src="`${assetsUrl}/${match.team2?.logo}`"
                    width="80px"
                    height="auto"
                    contain
                    class="ml-5"
                >
            </div>
        </v-col>
    </v-row>
</template>

<script>
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    export default {
        props: {
            type: {
                type: String,
                default: null
            },
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            // team colours that show on the black card and differ from each other
            colors() {
                return getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.black)
            }
        },
        watch: {
            match: {
                handler() {
                    this.$forceUpdate()
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            getMade(team) {
                if (this.type === '2P') {
                    return team.twoPointsMade
                } else if (this.type === '3P') {
                    return team.threePointsMade
                } else if (this.type === '1P') {
                    return team.freeThrowsMade
                }
                return 0
            },
            getAttempts(team) {
                if (this.type === '2P') {
                    return team.twoPointAttempts
                } else if (this.type === '3P') {
                    return team.threePointAttempts
                } else if (this.type === '1P') {
                    return team.freeThrowAttempts
                }
                return 0
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }

    .circular-border {
        display: inline-flex;
        border: 2px solid #fff;     /* white border */
        border-radius: 50%;         /* make it circular */
        padding: 2px;               /* space between border and ring */
    }
</style>
